import axios from 'axios';
import { apiBaseUrl } from './api';
import { AudienceSet, IGeolocationSet } from '../types';

export const createOrUpdateLocationSet = async (args: {
  brandId: string;
  body: IGeolocationSet;
  locationSetId?: string;
}) => {
  const { brandId, body, locationSetId } = args;

  let params: any = { brandId };

  if (locationSetId) {
    params = { ...params, locationSetId };
  }

  const data = await axios.post(
    `${apiBaseUrl}/assets/facebook/location-sets`,
    body,
    { params },
  );

  return data?.data;
};

export const getBrandLocationSets = async (args: {
  brandId: string;
  primary?: boolean;
  archived?: boolean;
}) => {
  const { brandId, primary, archived } = args;

  let params: any = { brandId };

  if (archived !== undefined) params = { ...params, archived };

  if (primary !== undefined) params = { ...params, primary };

  const data = await axios.get(`${apiBaseUrl}/assets/facebook/location-sets`, {
    params,
  });

  return data?.data;
};

export const getSingleBrandLocationSets = async (
  brandId: string,
  locationSetId: string,
) => {
  const data = await axios.get(
    `${apiBaseUrl}/assets/facebook/location-sets/${locationSetId}`,
    {
      params: { brandId },
    },
  );

  return data?.data;
};

export const createOrUpdateAudienceSet = async (args: {
  brandId: string;
  body: AudienceSet;
  audienceSetId?: string;
}) => {
  const { brandId, body, audienceSetId } = args;
  let params: any = { brandId };

  if (audienceSetId) {
    params = { ...params, audienceSetId };
  }

  const data = await axios.post(
    `${apiBaseUrl}/assets/facebook/audience-sets`,
    body,
    { params },
  );

  return data?.data;
};

export const getBrandAudienceSets = async (args: {
  brandId: string;
  primary?: boolean;
  archived?: boolean;
}) => {
  const { brandId, primary, archived } = args;

  let params: any = { brandId };

  if (archived !== undefined) params = { ...params, archived };

  if (primary !== undefined) params = { ...params, primary };

  const data = await axios.get(`${apiBaseUrl}/assets/facebook/audience-sets`, {
    params,
  });

  return data?.data;
};

export const getSingleBrandAudienceSets = async (
  brandId: string,
  audienceSetId: string,
) => {
  const data = await axios.get(
    `${apiBaseUrl}/assets/facebook/audience-sets/${audienceSetId}`,
    {
      params: { brandId },
    },
  );

  return data?.data;
};

export const createOrUpdateDemographicsSet = async (args: {
  brandId: string;
  body: AudienceSet;
  demographicsSetId?: string;
}) => {
  const { brandId, body, demographicsSetId } = args;
  let params: any = { brandId };

  if (demographicsSetId) params = { ...params, demographicsSetId };

  const data = await axios.post(
    `${apiBaseUrl}/assets/facebook/demographics-sets`,
    body,
    { params },
  );

  return data?.data;
};

export const getBrandDemographicsSets = async (args: {
  brandId: string;
  primary?: boolean;
  archived?: boolean;
}) => {
  const { brandId, primary, archived } = args;

  let params: any = { brandId, archived };

  if (archived !== undefined) params = { ...params, archived };

  if (primary !== undefined) params = { ...params, primary };

  const data = await axios.get(
    `${apiBaseUrl}/assets/facebook/demographics-sets`,
    {
      params,
    },
  );

  return data?.data;
};

export const getSingleBrandDemographicsSets = async (
  brandId: string,
  demographicsSetId: string,
) => {
  const data = await axios.get(
    `${apiBaseUrl}/assets/facebook/demographics-sets/${demographicsSetId}`,
    {
      params: { brandId },
    },
  );

  return data?.data;
};
